import { useState } from "react";
import { BookOpen, ChartNoAxesCombined } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LibroCassa } from "../libroCassa/LibroCassa";
import { StatisticsView } from "./StatisticsView";

export const ContabWorkspace = props => {
    const [view, setView] = useState("libro");
    return <div className="min-w-0 max-w-full" data-testid="contab-workspace">
        <nav aria-label="Analisi contabile" className="flex gap-2 flex-wrap border-b border-[#9AA2AD]/20 pb-3" data-testid="contab-inner-navigation">
            <Button variant="ghost" aria-pressed={view === "libro"} data-testid="contab-view-libro" onClick={() => setView("libro")} className={`gap-2 rounded-none ${view === "libro" ? "bg-[#E2231A] text-white hover:bg-[#C11B15]" : "text-[#9AA2AD]"}`}><BookOpen size={16} />Libro Cassa</Button>
            <Button variant="ghost" aria-pressed={view === "statistiche"} data-testid="contab-view-statistiche" onClick={() => setView("statistiche")} className={`gap-2 rounded-none ${view === "statistiche" ? "bg-[#E2231A] text-white hover:bg-[#C11B15]" : "text-[#9AA2AD]"}`}><ChartNoAxesCombined size={16} />Statistiche</Button>
        </nav>
        {view === "libro" ? <LibroCassa {...props} /> : <StatisticsView {...props} />}
    </div>;
};